import type { IComponentController } from "angular";
import "angular-translate";

import "angular-moment";

import type { IProfileService } from "App/Modules/Auth";
import type { ISiteSlim } from "App/Modules/Models";
import type { IHumanizeDurationService } from "App/Modules/Services";
import type { IEventsTableEntry } from "./Models/IEventsTableEntry";

export default class EventsTableComponentController implements IComponentController {
    public static $inject = [
        "$scope",
        "$element",
        "irHumanizeDurationService",
        "mmProfileService",
        "$translate",
        "$location",
    ];

    public eventsTableEntries: IEventsTableEntry[];

    public site: ISiteSlim;

    public totalItems: number;

    public maxEntriesShown = 500;

    constructor(
        private readonly $scope: ng.IScope,
        private readonly $element: ng.IAugmentedJQuery,
        private readonly humanizeDurationService: IHumanizeDurationService,
        private readonly profileService: IProfileService,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly $location: ng.ILocationService,
    ) {}

    public $onChanges() {
        if (this.eventsTableEntries) {
            this.totalItems = this.eventsTableEntries.length;
        }
    }

    public isEvent(entry: IEventsTableEntry): entry is IEventsTableEntry {
        return entry.entryTypeBase === "Event";
    }

    public isLegacyIssue(entry: IEventsTableEntry): entry is IEventsTableEntry {
        return (
            entry.entryTypeName === "NoHeartbeatReceived" ||
            entry.entryTypeName === "NoImageReceived" ||
            entry.entryTypeName === "NoImageFromCamera"
        );
    }

    public toggleShowDetails(entry: IEventsTableEntry, $event: angular.IAngularEvent) {
        if (entry.entryTypeBase === "Event") {
            entry.showDetails = !entry.showDetails;
            $event.stopPropagation();
        }
    }

    public localizedTimestamp(entry: IEventsTableEntry) {
        return entry.dtEntry.clone().format("L LT");
    }

    public relativeTime(entry: IEventsTableEntry) {
        return entry.dtEntry.clone().fromNow();
    }
}
